var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import striptags from 'striptags';
import { classNames, useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { ButtonDropdown } from 'components/ButtonDropdown';
import { FormInput } from 'components/form/FormInput';
import { Icon } from 'components/Icon';
import { Money } from 'components/Money';
import { DealItemDiscountedPrice } from './DealItemDiscountedPrice';
import { DateTime } from 'components/DateTime';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { React } from 'libs/react';
import { getMarkup, getMargin, getPriceFromItem, getPricePerUnitFromMarkup, getPricePerUnitFromMargin } from 'helpers/Pricing';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { DealModalDeleteConfirmation } from '../../modal/DealModalDeleteConfirmation';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { useUser } from 'components/user/UserProvider';
import { Button } from 'components/Button';
import { Image } from 'components/Image';
import { getMixpanel } from 'helpers/Mixpanel';
import { formatFieldValue } from 'helpers/Field';
import { getTimeSlotDate } from 'helpers/timeSlot';
import { DealItemEditModal } from '../../modal/DealItemEditModal';
import { DealAvailabilityModal } from '../../../modal/DealAvailabilityModal';
import { useModal } from 'components/modal/ModalStack';
import i18n from 'components/translation/i18n';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import { useDealDetailContext } from 'modules/deal/DealDetails';
import { QuoteMedia } from 'modules/public/quote/components/QuoteMedia';
import { useBreakpoint } from 'components/util/BreakpointProvider';
import { getUnitOfMeasurementLabel } from 'modules/catalog/saleItem/forms/SaleItemForm';
import { showBundledQuoteConfigurationQuantity } from 'helpers/quoteBundled';
import { getConfigurationEffectiveQuantity, getConfigurationQuantitySuffix } from 'helpers/DealQuantity';
import '../DealItemPanelGroupContent.scss';
import { useAccount } from 'components/account/AccountProvider';
export function OptionListItem(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
    const { item, data, editable, hideSKU, itemsGrouped, discountRep, pricingDisplay, pricingParametersDisplay, quantityType } = props;
    const user = useUser();
    const modal = useModal();
    const breakpoint = useBreakpoint();
    const _12 = useDealConfiguratorContext(), { proposeOption, includeOption, changePriceDisplay, hideDealItemConfiguration, onItemPriceChange, deal, onOptionQuantityChange, updateOptionFieldValues, updateMarkupPerItem, updateOptions, onMoveItemConfiguration, configurationFields, hasDealItemConfigurationTime: hasDealItemConfigurationTimeCfg } = _12, dealConfiguratorContext = __rest(_12, ["proposeOption", "includeOption", "changePriceDisplay", "hideDealItemConfiguration", "onItemPriceChange", "deal", "onOptionQuantityChange", "updateOptionFieldValues", "updateMarkupPerItem", "updateOptions", "onMoveItemConfiguration", "configurationFields", "hasDealItemConfigurationTime"]);
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    const quoteContext = useQuoteContext();
    const hasDealItemConfigurationTime = hasDealItemConfigurationTimeCfg ||
        quoteContext.hasDealItemConfigurationTime;
    const dealDetailContext = useDealDetailContext();
    const quantityTypeValue = quantityType && quantityType != ''
        ? quantityType
        : dealConfiguratorContext.quantityType != ''
            ? dealConfiguratorContext.quantityType
            : quoteContext.quantityType;
    const quoteDealItemConfigurationFields = quoteContext.dealItemConfigurationFields.length > 0
        ? quoteContext.dealItemConfigurationFields
        : dealDetailContext.dealItemConfigurationFields.length > 0
            ? dealDetailContext.dealItemConfigurationFields
            : dealConfiguratorContext.dealItemConfigurationFields;
    const dealValue = deal !== null && deal !== void 0 ? deal : quoteContext.deal;
    const showLineDiscount = !editable && !!(dealValue === null || dealValue === void 0 ? void 0 : dealValue.showDiscount) && pricingDisplay !== 'BUNDLED';
    const effectiveQuantity = getConfigurationEffectiveQuantity(data.quantity, (_a = data.item) === null || _a === void 0 ? void 0 : _a.quantityCalculation, dealValue);
    const quantitySuffix = getConfigurationQuantitySuffix((_b = data.item) === null || _b === void 0 ? void 0 : _b.quantityCalculation, dealValue, getUnitOfMeasurementLabel((_c = data.item) === null || _c === void 0 ? void 0 : _c.unitOfMeasurement));
    const showConfigurationQuantity = showBundledQuoteConfigurationQuantity(data, pricingDisplay, editable);
    const pricingParameters = dealConfiguratorContext
        ? dealConfiguratorContext.pricingParameters
        : quoteContext.pricingParameters;
    const itemSorting = (_f = JSON.parse((_e = (_d = configurationFields.find((conf) => conf.fieldKey === 'ITEM_SORTING')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '{}')) === null || _f === void 0 ? void 0 : _f.value;
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [openModalEditFields, setOpenModalEditFields] = useState(false);
    const [openModalAvailability, setOpenModalAvailability] = useState(false);
    const [costPrice, setCostPrice] = useState(getPriceFromItem(item.item, (_g = item.variant) !== null && _g !== void 0 ? _g : null, (_h = data.item) !== null && _h !== void 0 ? _h : null, 'option', deal === null || deal === void 0 ? void 0 : deal.currency));
    const [amount, setAmount] = useState((_j = data.price) !== null && _j !== void 0 ? _j : 0);
    const dealerDiscount = (discountRep * costPrice) / 100;
    const dealerPrice = costPrice - dealerDiscount;
    const [markup, setMarkup] = useState(getMarkup(dealerPrice, amount).toFixed(0).toString());
    const [margin, setMargin] = useState(getMargin(dealerPrice, amount).toFixed(0).toString());
    const [discount, setDiscount] = useState(dealerPrice !== 0
        ? Number((((dealerPrice - amount) / dealerPrice) * 100).toFixed(2))
        : 0);
    const [pricePerUnit, setPricePerUnit] = useState(Number.isFinite(amount) ? amount.toFixed(2).toString() : '0');
    const [userInputMarkup, setUserInputMarkup] = useState(false);
    const [userInputMargin, setUserInputMargin] = useState(false);
    const [userInputDiscount, setUserInputDiscount] = useState(false);
    const [userInputPricePerUnit, setUserInputPricePerUnit] = useState(true);
    const [quantity, setQuantity] = useState(data.quantity);
    const markupRef = useRef(null);
    const marginRef = useRef(null);
    const discountRef = useRef(null);
    const pricePerUnitRef = useRef(null);
    useEffect(() => {
        setPricePerUnit(Number.isFinite(dealerPrice) ? dealerPrice.toFixed(2) : '0');
    }, [amount]);
    useEffect(() => {
        var _a;
        setQuantity(data.quantity);
        const newPrice = (_a = data.price) !== null && _a !== void 0 ? _a : 0;
        setPricePerUnit(Number.isFinite(newPrice) ? newPrice.toFixed(2).toString() : '0');
        setMarkup(getMarkup(dealerPrice, newPrice).toFixed(0).toString());
        setMargin(getMargin(dealerPrice, newPrice).toFixed(0).toString());
        setDiscount(dealerPrice !== 0
            ? Number((((dealerPrice - newPrice) / dealerPrice) * 100).toFixed(2))
            : 0);
    }, [data, dealerPrice]);
    useEffect(() => {
        var _a, _b;
        setCostPrice(getPriceFromItem(item.item, (_a = item.variant) !== null && _a !== void 0 ? _a : null, (_b = data.item) !== null && _b !== void 0 ? _b : null, 'option', deal === null || deal === void 0 ? void 0 : deal.currency));
    }, [deal === null || deal === void 0 ? void 0 : deal.currency]);
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChange = (value) => {
        setQuantity(Number(value));
    };
    /**
     * @function onQuantityChangeOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChangeOnBlur = () => {
        if (quantity !== data.quantity) {
            const onQuantityChangeHandler = deal
                ? onOptionQuantityChange
                : quoteContext.onOptionQuantityChange;
            onQuantityChangeHandler(item, data, quantity);
        }
    };
    /**
     * @function onMarkupChange
     * @since 1.0.0
     * @hidden
     */
    const onMarkupChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMarkup(dealerPrice, Number(value));
        setMarkup(value);
        updateMarkupPerItem(data.id, Number(value), false);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onMarginChange
     * @since 1.0.0
     * @hidden
     */
    const onMarginChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMargin(dealerPrice, Number(value));
        setMargin(value);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onDiscountChange
     * @since 1.0.0
     * @hidden
     */
    const onDiscountChange = (value) => {
        const pricePerUnit = dealerPrice - dealerPrice * (Number(value) / 100);
        setDiscount(Number(value));
        setPricePerUnit(pricePerUnit.toFixed(2));
        onPriceChange(pricePerUnit);
    };
    /**
     * @function onPricePerUnitChange
     * @since 1.0.0
     * @hidden
     */
    const onPricePerUnitChange = (value) => {
        const markup = getMarkup(dealerPrice, Number(value)).toFixed(0);
        const margin = getMargin(dealerPrice, Number(value)).toFixed(0);
        const discount = ((dealerPrice - Number(value)) / dealerPrice) * 100;
        setPricePerUnit(value);
        setMarkup(markup);
        setMargin(margin);
        setDiscount(Number(discount.toFixed(2)));
        updateMarkupPerItem(data.id, Number(markup), false);
    };
    /**
     * @function onPriceChange
     * @since 1.0.0
     * @hidden
     */
    const onPriceChange = (value) => {
        const dealItem = deal === null || deal === void 0 ? void 0 : deal.items.find((i) => i.id === item.id);
        if (dealItem && dealItem.options && (data === null || data === void 0 ? void 0 : data.id)) {
            const tempOptions = [...dealItem.options];
            const optionIndex = dealItem.options.findIndex((option) => option.id === (data === null || data === void 0 ? void 0 : data.id));
            if (optionIndex > -1) {
                tempOptions[optionIndex] = Object.assign(Object.assign({}, tempOptions[optionIndex]), { price: value });
                onItemPriceChange &&
                    onItemPriceChange(Object.assign(Object.assign({}, dealItem), { options: tempOptions }));
            }
        }
    };
    /**
     * @function onItemPriceOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onPriceOnBlur = () => {
        onPriceChange(Number(pricePerUnit));
    };
    /**
     * @function onMarkupClick
     * @since 1.0.0
     * @hidden
     */
    const onMarkupClick = () => {
        var _a;
        setUserInputMarkup(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = markupRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onMarginClick
     * @since 1.0.0
     * @hidden
     */
    const onMarginClick = () => {
        var _a;
        setUserInputMarkup(false);
        setUserInputMargin(true);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = marginRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onDiscountClick
     * @since 1.0.0
     * @hidden
     */
    const onDiscountClick = () => {
        var _a;
        setUserInputMarkup(false);
        setUserInputMargin(false);
        setUserInputDiscount(true);
        setUserInputPricePerUnit(false);
        (_a = discountRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onPricePerUnitClick
     * @since 1.0.0
     * @hidden
     */
    const onPricePerUnitClick = () => {
        var _a;
        setUserInputPricePerUnit(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputMarkup(false);
        (_a = pricePerUnitRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onManageOption
     * @since 1.0.0
     * @hidden
     */
    function onManageOption(value) {
        var _a;
        const itemValue = dealValue === null || dealValue === void 0 ? void 0 : dealValue.items.find((i) => i.id === item.id);
        switch (value) {
            case 'propose':
                if (itemValue) {
                    proposeOption(itemValue, data);
                }
                break;
            case 'include':
                includeOption(item, data, false);
                break;
            case 'alternative':
                updateOptions(itemValue !== null && itemValue !== void 0 ? itemValue : item, (_a = data.item) === null || _a === void 0 ? void 0 : _a.id);
                break;
            case 'hide':
                hideDealItemConfiguration(item, data, 'option');
                break;
            case 'showAmount':
                changePriceDisplay(item, data, true, 'option', 'AMOUNT');
                break;
            case 'includedWithoutPrice':
                changePriceDisplay(item, data, false, 'option', 'INCLUDED');
                break;
            case 'includeWithPrice':
                changePriceDisplay(item, data, true, 'option', 'INCLUDED');
                break;
            case 'hideAmount':
                changePriceDisplay(item, data, true, 'option', 'NONE');
                break;
            case 'default':
                changePriceDisplay(item, data, true, 'option', 'DEFAULT');
                break;
            case 'moveUp':
                onMoveItemConfiguration(item, data, 'option', 'up');
                break;
            case 'moveDown':
                onMoveItemConfiguration(item, data, 'option', 'down');
                break;
            case 'checkAvailability':
                setOpenModalAvailability(true);
                break;
            case 'delete':
                setOpenModalDelete(true);
                break;
        }
    }
    /**
     * @function onCloseModal
     * @since 1.0.0
     * @hidden
     */
    const onCloseModal = () => {
        if (openModalDelete) {
            setOpenModalDelete(false);
        }
        if (openModalEditFields) {
            setOpenModalEditFields(false);
        }
        if (openModalAvailability) {
            setOpenModalAvailability(false);
        }
    };
    /**
     * @function onEditPress
     * @since 1.0.0
     * @hidden
     */
    function onEditPress() {
        setOpenModalEditFields(true);
    }
    const dropdown = [];
    const visibilityDropdown = [];
    dropdown.push({
        value: 'propose',
        picto: 'heart',
        label: t('Suggest')
    });
    dropdown.push({
        value: 'alternative',
        picto: 'right-left',
        label: t('Alternative')
    });
    if (data.priceDisplay === 'INCLUDED') {
        dropdown.push({
            value: 'default',
            picto: 'rotate-left',
            label: t('Reset default pricing')
        });
    }
    else {
        dropdown.push({
            value: 'includedWithoutPrice',
            picto: 'check',
            label: t('Include (Free)')
        });
        dropdown.push({
            value: 'includeWithPrice',
            picto: 'plus',
            label: t('Include (Charged)')
        });
    }
    if (data.priceDisplay !== 'AMOUNT') {
        visibilityDropdown.push({
            value: 'showAmount',
            picto: 'dollar-sign',
            label: t('Show amount')
        });
    }
    else {
        visibilityDropdown.push({
            value: 'hideAmount',
            picto: 'eye-slash',
            label: t('Hide amount')
        });
    }
    if (data.hide) {
        visibilityDropdown.push({
            value: 'hide',
            picto: 'eye',
            label: t('Show line')
        });
    }
    else {
        visibilityDropdown.push({
            value: 'hide',
            picto: 'eye-slash',
            label: t('Hide line')
        });
    }
    if (itemSorting === 'ORDER') {
        visibilityDropdown.push({
            value: 'moveUp',
            picto: 'arrow-up',
            label: t('Move up')
        });
        visibilityDropdown.push({
            value: 'moveDown',
            picto: 'arrow-down',
            label: t('Move down')
        });
    }
    visibilityDropdown.push({
        value: 'delete',
        picto: 'times',
        label: t('Remove')
    });
    if (user.can('calendar.availability.check')) {
        dropdown.push({
            value: 'checkAvailability',
            picto: 'calendar-check',
            label: t('Check availability')
        });
    }
    /**
     * @component onPressRemoveOption
     * @since 1.0.0
     * @hidden
     */
    const onPressRemoveOption = () => {
        var _a, _b, _c;
        getMixpanel((_a = user.user) === null || _a === void 0 ? void 0 : _a.email, 'Remove recommended option', {
            item: (_b = data.item) === null || _b === void 0 ? void 0 : _b.title
        });
        const itemWithProposedOption = (_c = quoteContext.deal) === null || _c === void 0 ? void 0 : _c.items.find((i) => i.id === item.id);
        quoteContext.proposeOptionQuote(itemWithProposedOption !== null && itemWithProposedOption !== void 0 ? itemWithProposedOption : item, data);
    };
    /**
     * @function onSaleItemDetail
     * @since 1.0.0
     * @hidden
     */
    function onSaleItemDetail() {
        var _a;
        if (data === null || data === void 0 ? void 0 : data.item) {
            modal.present({
                title: hideSKU === 'FALSE' ? (_a = data === null || data === void 0 ? void 0 : data.item) === null || _a === void 0 ? void 0 : _a.sku : undefined,
                picto: '',
                className: 'deal-sale-item-selector-item-modal',
                modal: (React.createElement(SaleItemViewer, { item: data.item, lang: quoteLanguage !== null && quoteLanguage !== void 0 ? quoteLanguage : undefined }))
            });
        }
    }
    /**
     * @function openFile
     * @since 1.0.0
     * @hidden
     */
    function openFile(file) {
        modal.present({
            title: file.file.filename,
            picto: '',
            className: 'deal-sale-item-selector-item-modal',
            modal: (React.createElement("div", { className: "deal-sale-item-selector-item-modal-file" },
                React.createElement("embed", { src: file.file.url, width: "100%", height: "100%" })))
        });
    }
    /**
     * @function isAlternative
     * @since 1.0.0
     * @hidden
     */
    function isAlternative(data) {
        var _a, _b;
        const isAlternative = (_b = (_a = dealValue === null || dealValue === void 0 ? void 0 : dealValue.items.find((i) => i.id === item.id)) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find((opt) => { var _a; return opt.alternativeTo === ((_a = data.item) === null || _a === void 0 ? void 0 : _a.id); });
        return !!isAlternative;
    }
    let itemTitle = (_k = data.item) === null || _k === void 0 ? void 0 : _k.title;
    if (((_l = data.item) === null || _l === void 0 ? void 0 : _l.title) && ((_m = data.item) === null || _m === void 0 ? void 0 : _m.title.length) > 60) {
        itemTitle = (_o = data.item) === null || _o === void 0 ? void 0 : _o.title.slice(0, 60).concat('...');
    }
    const quoteLanguage = dealValue === null || dealValue === void 0 ? void 0 : dealValue.language;
    const publicFiles = (_r = (_q = (_p = data.item) === null || _p === void 0 ? void 0 : _p.files) === null || _q === void 0 ? void 0 : _q.filter((file) => file.visibility === 'PUBLIC')) !== null && _r !== void 0 ? _r : [];
    const languageFiles = publicFiles.filter((file) => !file.language || !quoteLanguage || file.language.code === quoteLanguage);
    const filteredFiles = languageFiles.length > 0 ? languageFiles : publicFiles;
    // Check if item have infos or image
    const hasInfos = !!((_s = data.item) === null || _s === void 0 ? void 0 : _s.infos);
    const hasSummary = !!((_t = data.item) === null || _t === void 0 ? void 0 : _t.summary) && !!striptags(data.item.summary).trim();
    const hasImage = !!((_u = data.item) === null || _u === void 0 ? void 0 : _u.image) && !!data.item.image.image.url;
    const isClickable = hasInfos || hasImage || hasSummary;
    const className = classNames({ 'deal-item-panel-group-content--proposed': data.proposed }, { 'deal-item-panel-group-content--isClickable': isClickable && !editable }, { 'deal-item-panel-group-content--hide': data.hide }, props.className);
    return editable || (!editable && breakpoint.isAboveOrEqual('md')) ? (React.createElement(React.Fragment, null,
        React.createElement("tr", { className: className, onClick: isClickable && !editable ? onSaleItemDetail : undefined },
            React.createElement("td", { className: "deal-item-panel-group-content-cell--primary", "data-label": t('Option') },
                React.createElement("div", { className: "deal-item-panel-group-content-cell--primary--title" },
                    !((_v = data.item) === null || _v === void 0 ? void 0 : _v.active) || data.item.deletedAt ? (React.createElement(Icon, { value: "exclamation-triangle", style: "danger", tooltip: t('This item is no longer available.') })) : hasImage ? (React.createElement(Image, { className: "table-row-image", source: (_y = (_x = (_w = data.item) === null || _w === void 0 ? void 0 : _w.image) === null || _x === void 0 ? void 0 : _x.image.url) !== null && _y !== void 0 ? _y : '', onClick: editable ? onSaleItemDetail : undefined })) : hasInfos || hasSummary ? (React.createElement(Button, { style: "picto", picto: "circle-info", onPress: editable ? onSaleItemDetail : undefined })) : (React.createElement(Button, { style: "picto", picto: "", disabled: true })),
                    React.createElement(Text, { className: "deal-item-panel-group-content-value", value: itemTitle, onClick: editable ? onSaleItemDetail : undefined }),
                    filteredFiles && (filteredFiles === null || filteredFiles === void 0 ? void 0 : filteredFiles.length) > 0 && (React.createElement("div", { className: "deal-item-panel-group-content-cell--files", onClick: (e) => e.stopPropagation() }, filteredFiles.map((file) => (React.createElement(Icon, { value: "paperclip", onClick: () => openFile(file), key: file.id }))))))),
            hideSKU === 'FALSE' && (React.createElement("td", { "data-label": t('SKU') },
                React.createElement(Text, { className: "deal-item-panel-group-content-value deal-item-panel-group-content-value--sku", value: (_z = data.item) === null || _z === void 0 ? void 0 : _z.sku }))),
            (!itemsGrouped || editable) && (React.createElement("td", { "data-label": t('Group') },
                React.createElement(Text, { className: classNames({ 'deal-item-panel-group-content-value': true }, {
                        'deal-item-panel-group-content-value--group': (_0 = data.item) === null || _0 === void 0 ? void 0 : _0.group
                    }), value: (_2 = (_1 = data.item) === null || _1 === void 0 ? void 0 : _1.group) === null || _2 === void 0 ? void 0 : _2.title }))),
            hasDealItemConfigurationTime && (React.createElement("td", { className: "field-cell", "data-label": t('Time') }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, data.startTime || data.endTime ? (React.createElement("span", { className: "deal-item-panel-group-content-value" },
                data.startTime && (React.createElement(DateTime, { date: false, time: true, value: data.startTime, hh: "2-digit", mm: "2-digit" })),
                data.startTime && data.endTime && ' — ',
                data.endTime && (React.createElement(DateTime, { date: false, time: true, value: data.endTime, hh: "2-digit", mm: "2-digit" })))) : (React.createElement(Button, { style: "picto", picto: "clock" })))) : data.startTime || data.endTime ? (React.createElement("span", { className: "deal-item-panel-group-content-value" },
                data.startTime && (React.createElement(DateTime, { date: false, time: true, value: data.startTime, hh: "2-digit", mm: "2-digit" })),
                data.startTime && data.endTime && ' — ',
                data.endTime && (React.createElement(DateTime, { date: false, time: true, value: data.endTime, hh: "2-digit", mm: "2-digit" })))) : null)),
            quoteDealItemConfigurationFields.length > 0
                ? quoteDealItemConfigurationFields === null || quoteDealItemConfigurationFields === void 0 ? void 0 : quoteDealItemConfigurationFields.map((field) => {
                    var _a, _b;
                    const v = (_b = (_a = data.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => { var _a; return ((_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id) === field.id; })) === null || _b === void 0 ? void 0 : _b.value;
                    return (React.createElement("td", { key: field.id, className: "field-cell" }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, v ? (field.type === 'FILE' ? (React.createElement(Icon, { value: "file" })) : (React.createElement(React.Fragment, null,
                        React.createElement(Text, { className: "deal-item-panel-group-content-value", value: formatFieldValue(v, field.type, field, i18n.language) }),
                        React.createElement(Icon, { value: "pencil" })))) : (React.createElement(Button, { picto: field.type === 'DATE'
                            ? 'calendar'
                            : field.type === 'TIME'
                                ? 'clock'
                                : 'plus', style: "picto" })))) : field.type === 'FILE' ? (React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(v, field.type, field), noLabel: true })) : (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: v
                            ? formatFieldValue(v, field.type, field, i18n.language)
                            : '' }))));
                })
                : null,
            (quantityTypeValue === 'GRANULAR' ||
                quantityTypeValue === 'ITEM_CONFIGURATION') && (React.createElement("td", { "data-label": t('Quantity'), className: "deal-item-panel-group-content-value--qty" }, editable ? (React.createElement(FormInput, { className: "deal-item-panel-group-content-input input-quantity", type: "number", name: "quantity", value: quantity.toString(), onChange: (value) => onQuantityChange(value), onBlur: onQuantityChangeOnBlur, min: "0", size: "small", suffix: quantitySuffix })) : showConfigurationQuantity ? (React.createElement("div", { className: "deal-item-panel-group-content-value--uneditable-qty" },
                React.createElement(Text, { className: "deal-item-panel-group-content-value", value: quantity.toString() }),
                React.createElement(Case, { is: !!quantitySuffix },
                    React.createElement(Text, { className: "deal-item-panel-group-content-value--unitOfMeasurement", value: quantitySuffix })))) : null)),
            React.createElement(Case, { is: editable },
                React.createElement("td", { "data-label": t('Price'), className: "deal-item-panel-group-content-price" },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: costPrice }))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer discount'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerDiscount })))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer price'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerPrice })))),
            editable && pricingParameters === 'DISCOUNT' && (React.createElement("td", { "data-label": t('Discount') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onDiscountClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputDiscount ? onDiscountChange : undefined, value: discount.toString(), disabled: userInputDiscount ? false : true, className: userInputDiscount ? 'number-input isActive' : 'number-input', ref: discountRef, size: "small" }),
                React.createElement(Icon, { value: userInputDiscount ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARKUP' &&
                pricingParametersDisplay == 'line' && (React.createElement("td", { "data-label": t('Markup') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon-content", onClick: onMarkupClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMarkup ? onMarkupChange : undefined, value: markup, disabled: userInputMarkup ? false : true, className: userInputMarkup ? 'number-input isActive' : 'number-input', ref: markupRef, size: "small" }),
                React.createElement(Icon, { value: userInputMarkup ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARGIN' &&
                pricingParametersDisplay == 'line' && (React.createElement("td", { "data-label": t('Margin') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon-content", onClick: onMarginClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMargin ? onMarginChange : undefined, value: margin, disabled: userInputMargin ? false : true, className: userInputMargin ? 'number-input isActive' : 'number-input', ref: marginRef, size: "small" }),
                React.createElement(Icon, { value: userInputMargin ? 'angle-left' : 'angle-right' }))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Selling Price') + ' ($)', className: "deal-item-panel-group-content-input input-profit deal-item-panel-group-content-price", onClick: onPricePerUnitClick }, editable ? (React.createElement(FormInput, { type: "number", suffix: "$", onChange: userInputPricePerUnit ? onPricePerUnitChange : undefined, onBlur: onPriceOnBlur, value: pricePerUnit, disabled: userInputPricePerUnit ? false : true, className: userInputPricePerUnit
                    ? 'number-input isActive'
                    : 'number-input', ref: pricePerUnitRef, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        onPriceOnBlur();
                    }
                }, size: "small" })) : data.priceDisplay === 'INCLUDED' ? (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: t('Included') })) : data.priceDisplay === 'AMOUNT' ? (React.createElement(DealItemDiscountedPrice, { className: "deal-item-panel-group-content-value", value: Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount })) : null)),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Total'), className: "deal-item-panel-group-content-price" },
                data.priceDisplay === 'INCLUDED' && (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: t('Included') })),
                data.priceDisplay === 'AMOUNT' && (React.createElement(Money, { className: "deal-item-panel-group-content-value", value: Number(pricePerUnit) * effectiveQuantity })))),
            React.createElement("td", { "data-label": t('Actions') }, data.priceDisplay === 'INCLUDED' && !editable ? (React.createElement(Icon, { value: "hexagon-check", className: "deal-item-panel-group-content-lock-icon" })) : editable ? (React.createElement("div", { className: "cell-button-actions" },
                React.createElement(ButtonDropdown, { picto: "eye", options: visibilityDropdown, onSelect: onManageOption, className: "first" }),
                React.createElement(ButtonDropdown, { options: dropdown, onSelect: onManageOption, className: "last" }))) : isAlternative(data) ? (React.createElement("div", { onClick: (e) => e.stopPropagation() },
                React.createElement(Button, { style: "picto", picto: "right-left", className: "deal-item-panel-group-content-add-proposed-button deal-item-panel-group-content-add-proposed-button--alternative", onPress: onPressRemoveOption }))) : (data.initiallyProposed && (React.createElement("div", { onClick: (e) => e.stopPropagation() },
                React.createElement(Button, { style: "picto", picto: "minus", className: "deal-item-panel-group-content-add-proposed-button", onPress: onPressRemoveOption })))))),
        openModalAvailability && dealValue && (React.createElement(DealAvailabilityModal, { deal: dealValue, onClose: () => setOpenModalAvailability(false), saleItemId: (_3 = data.item) === null || _3 === void 0 ? void 0 : _3.id, saleItemTitle: (_4 = data.item) === null || _4 === void 0 ? void 0 : _4.title, isOption: true })),
        openModalDelete && (React.createElement(DealModalDeleteConfirmation, { type: 'option', item: item, configuration: data, onClose: onCloseModal, deleteConfirmationMessage: `${t('Delete')} ${(_5 = data.item) === null || _5 === void 0 ? void 0 : _5.title}?` })),
        openModalEditFields && (React.createElement(DealItemEditModal, { type: "option", item: data, customFields: quoteDealItemConfigurationFields, hasTime: hasDealItemConfigurationTime, timeSlotCheck: deal
                ? {
                    dealId: deal.id,
                    date: getTimeSlotDate(item.date, deal.plannedDateStart)
                }
                : undefined, onClose: onCloseModal, onUpdateItem: (updatedItem, applyToAll) => {
                var _a, _b, _c;
                const cfg = updatedItem;
                updateOptionFieldValues(item.id, updatedItem.id, (_a = updatedItem.fieldValues) !== null && _a !== void 0 ? _a : [], applyToAll, hasDealItemConfigurationTime
                    ? ((_b = cfg.startTime) !== null && _b !== void 0 ? _b : null)
                    : undefined, hasDealItemConfigurationTime ? ((_c = cfg.endTime) !== null && _c !== void 0 ? _c : null) : undefined);
                setOpenModalEditFields(false);
            } })))) : (React.createElement("div", { className: "deal-item-panel-group__content--mobile" },
        React.createElement("div", { className: "deal-item-panel-group__content--mobile-row" },
            React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-picto" }, !item.item.active || item.item.deletedAt ? (React.createElement(Icon, { value: "exclamation-triangle", style: "danger", tooltip: t('This item is no longer available.') })) : hasImage ? (React.createElement(Image, { className: "table-row-image", source: (_8 = (_7 = (_6 = item.item) === null || _6 === void 0 ? void 0 : _6.image) === null || _7 === void 0 ? void 0 : _7.image.url) !== null && _8 !== void 0 ? _8 : '', onClick: onSaleItemDetail })) : hasInfos || hasSummary ? (React.createElement(Button, { style: "picto", picto: "circle-info", onPress: onSaleItemDetail })) : (React.createElement(Button, { style: "picto", picto: "", disabled: true }))),
            React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-value" },
                React.createElement(Text, { value: itemTitle, onClick: editable ? onSaleItemDetail : undefined })),
            pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ? (React.createElement("div", { className: "deal-item-panel-group__content--mobile-row-value" },
                data.priceDisplay === 'INCLUDED' && React.createElement(Text, { value: t('Included') }),
                data.priceDisplay === 'AMOUNT' && (React.createElement(Money, { value: Number(pricePerUnit) * effectiveQuantity })))) : null),
        React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow" },
            hideSKU === 'FALSE' && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('SKU')),
                React.createElement(Text, { className: "deal-item-panel-group__content--mobile-subrow--value", value: (_9 = data.item) === null || _9 === void 0 ? void 0 : _9.sku }))),
            !itemsGrouped && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Category')),
                React.createElement(Text, { value: (_11 = (_10 = data.item) === null || _10 === void 0 ? void 0 : _10.group) === null || _11 === void 0 ? void 0 : _11.title }))),
            (quantityTypeValue === 'GRANULAR' ||
                quantityTypeValue === 'ITEM_CONFIGURATION') &&
                showConfigurationQuantity && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Quantity')),
                React.createElement(Text, { value: quantity.toString() }))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE') && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Price')),
                data.priceDisplay === 'INCLUDED' ? (React.createElement(Text, { value: t('Included') })) : data.priceDisplay === 'AMOUNT' ? (React.createElement(DealItemDiscountedPrice, { value: Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount })) : null)),
            quoteDealItemConfigurationFields.length > 0
                ? quoteDealItemConfigurationFields === null || quoteDealItemConfigurationFields === void 0 ? void 0 : quoteDealItemConfigurationFields.map((field) => {
                    var _a, _b;
                    const v = (_b = (_a = data.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => { var _a; return ((_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id) === field.id; })) === null || _b === void 0 ? void 0 : _b.value;
                    return (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value", key: field.id },
                        React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, field.title),
                        field.type === 'FILE' ? (React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(v, field.type, field), noLabel: true })) : (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: v
                                ? formatFieldValue(v, field.type, field, i18n.language)
                                : '' }))));
                })
                : null,
            filteredFiles && (filteredFiles === null || filteredFiles === void 0 ? void 0 : filteredFiles.length) > 0 && (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value deal-item-panel-group-content-cell--files", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Files')),
                filteredFiles.map((file) => (React.createElement(Icon, { value: "paperclip", onClick: () => openFile(file), key: file.id }))))),
            data.priceDisplay === 'INCLUDED' ? (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Actions')),
                React.createElement(Icon, { value: "hexagon-check", className: "deal-item-panel-group-content-lock-icon" }))) : isAlternative(data) ? (React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow-value", onClick: (e) => e.stopPropagation() },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Actions')),
                React.createElement(Button, { style: "picto", picto: "right-left", className: "deal-item-panel-group-content-add-proposed-button deal-item-panel-group-content-add-proposed-button--alternative", onPress: onPressRemoveOption }))) : (data.initiallyProposed && (React.createElement("div", { onClick: (e) => e.stopPropagation(), className: "deal-item-panel-group__content--mobile-subrow-value" },
                React.createElement("div", { className: "deal-item-panel-group__content--mobile-subrow--title" }, t('Actions')),
                React.createElement(Button, { style: "picto", picto: "minus", className: "deal-item-panel-group-content-add-proposed-button", onPress: onPressRemoveOption })))))));
}
